import { ajax } from '../../../services/helper'
class ApiService {

    getHRTicketsData = (from,to,city_id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/hrTickets/list?from="+from+"&to="+to+"&city_id="+city_id
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }
   
    getHRTicketDetailsById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/hrTickets/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


      getEmployeeById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employees/"+id+"/view"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    
    
     addHRTicket = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/hrTickets/add"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    
    editHRTicket = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/hrTickets/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/HR/services/apiservices.js